// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"30":"8b65233041ae5d5f6cf4","489":"b90d9f86a45579152f6d"}[chunkId] + ".js";
};